import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Flex, Box } from 'grid-styled';
// import Moment from 'moment';
// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import H1 from 'components/H1/H1';
import Button from 'components/Button/Button';
import { ROUTE_ANALYSE_OVERVIEW } from '../../RouteList';
import {
  QUERY_GET_USERS,
  MUTATION_ARCHIVE_USER,
  MUTATION_UNARCHIVE_USER
} from '../../services/graphql';
import { Query, Mutation } from 'react-apollo';
import P from '../../components/P/P';

/*const formatTableDate = date =>
  Moment(date)
    .local()
    .format('DD-MM-YYYY HH:mm 24');*/

@inject('authStore', 'uiState', 'routing')
@observer
export default class Users extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  archive(mutation, uid) {
    const { uiState } = this.props;
    uiState.createAlert({
      title: 'Archiveer gebruiker',
      message: 'Bent u zeker dat u deze gebruiker wilt archiveren?',
      ok: 'Archiveer',
      okHandler: async () => {
        await mutation({ variables: { personId: uid } });
      },
      cancel: 'Annuleer'
    });
  }

  unArchive(mutation, uid) {
    const { uiState } = this.props;
    uiState.createAlert({
      title: 'Dearchiveer gebruiker',
      message: 'Bent u zeker dat u deze gebruiker wilt dearchiveren?',
      ok: 'Dearchiveer',
      okHandler: async () => {
        await mutation({ variables: { personId: uid } });
      },
      cancel: 'Annuleer'
    });
  }

  impersonate = user => {
    const { authStore, routing } = this.props;
    authStore.setImpersonator(user);
    routing.push(ROUTE_ANALYSE_OVERVIEW);
  };

  render() {
    return (
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        width={1 / 1}
        style={{ backgroundColor: 'rgb(30,100,200)' }}
        py={4}
      >
        <Box width={9 / 10}>
          <H1 small upper textcenter>
            list of Users
          </H1>
          <Query query={QUERY_GET_USERS} fetchPolicy={'cache-and-network'}>
            {({ loading, error, data }) => {
              if (loading) return <P>Bezig met laden...</P>;
              if (error) return <P danger>{error.message}</P>;
              const users = data && data.getPersons;
              if (!users) {
                return null;
              }
              return (
                <Box style={{ backgroundColor: 'white' }}>
                  <ReactTable
                    noDataText="Geen gebruikers gevonden"
                    style={{ fontFamily: 'Arial, sans-serif', lineHeight: 2 }}
                    data={users}
                    columns={[
                      {
                        id: 'email',
                        Header: 'Email',
                        accessor: d => d.email
                      },
                      {
                        id: 'name',
                        Header: 'Name',
                        accessor: d => `${d.firstname} ${d.lastname}`
                      },
                      {
                        id: 'Actions',
                        Header: 'Actions',
                        accessor: d => d,
                        Cell: row => (
                          <Flex>
                            <Box mr={2}>
                              <Button
                                onClick={() => this.impersonate(row.value)}
                                xSmall
                                primary
                              >
                                impersonate
                              </Button>
                            </Box>
                            {!row.value.archived && (
                              <Box mr={2}>
                                <Mutation
                                  mutation={MUTATION_ARCHIVE_USER}
                                  refetchQueries={[
                                    {
                                      query: QUERY_GET_USERS
                                    }
                                  ]}
                                >
                                  {(archivePerson, data) => {
                                    return (
                                      <Button
                                        danger
                                        xSmall
                                        disabled={data.loaded}
                                        onClick={() =>
                                          this.archive(
                                            archivePerson,
                                            row.value.id
                                          )
                                        }
                                      >
                                        archive
                                      </Button>
                                    );
                                  }}
                                </Mutation>
                              </Box>
                            )}
                            {row.value.archived && (
                              <Box mr={2}>
                                <Mutation
                                  mutation={MUTATION_UNARCHIVE_USER}
                                  refetchQueries={[
                                    {
                                      query: QUERY_GET_USERS
                                    }
                                  ]}
                                >
                                  {(unarchivePerson, data) => {
                                    return (
                                      <Button
                                        danger
                                        xSmall
                                        disabled={data.loaded}
                                        onClick={() =>
                                          this.unArchive(
                                            unarchivePerson,
                                            row.value.id
                                          )
                                        }
                                      >
                                        unarchive
                                      </Button>
                                    );
                                  }}
                                </Mutation>
                              </Box>
                            )}
                          </Flex>
                        )
                      }
                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                  />
                </Box>
              );
            }}
          </Query>
        </Box>
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/users/Users.js